/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import DetailFile from "../../components/DetailFile/DetailFile";
import { useParams } from "react-router-dom";
import { Loader } from "rsuite";
import CardC from "../../components/CustomCard/CardC";
import { Image } from "react-bootstrap";
import peticionBack from "../../libs/peticiones/peticionBack";
import { defaultStatus, statusAudio } from "./Main";
import { Status } from "../../enums/Status";

export default function FileApiViewer(){
    const [loading, setLoading] = useState<boolean>(true);
    const [archivo, setArchivo] = useState<any>();
    const [error, setError] = useState<string>("");
    const { file } = useParams();
    const [stateAudio, setStateAudio] = useState<statusAudio>(defaultStatus);
    

    useEffect(() => {
        getFile();
    }, []);

    async function getFile() {
        const res = await peticionBack({}, `/files/${encodeURIComponent(file || "")}`, "GET", false);
        if(res){
            setArchivo({
                pages: res.ocr?.data || [],
                type: res.mimetype.split("/")[1].toUpperCase(),
                src: res.src,
                name: res.ocr?.name || "Sin nombre",
                id: res._id,
                status: res.status,
              });
            if (res.tts) {
            setStateAudio(res.tts);
            } else {
            setStateAudio({ ...stateAudio, status: Status.NO_PROCESS });
            }
        }else{
            setError("bb");
        }
        setLoading(false);
    }

    return(
        <CardC>
            <div className="w-100" style={{minHeight: "300px"}}>
                {
                    loading ? <Loader center size="md" /> :
                    error ? <ErrorMessage err={error} /> :
                    <DetailFile archivo={archivo} route={file} hookStateAudio={[stateAudio, setStateAudio]} />
                }
            </div>
        </CardC>
    )
}

function ErrorMessage({ err }: { err: string }){
    const keys: any = {
        aa: {ico: "lock", msg: "No es posible consultar el archivo", css: "bounce"},
        bb: {ico: "file-search", msg: "No se encontró el archivo", css: "shake"},
    }
    return(
        <div>
            <div className="my-1">
              <div className="stage">
                <div className={`box ${keys[err].css}-6 text-center`}>
                    <Image src={`/images/${keys[err].ico}.svg`} alt="lock-file" height={120} width={120} />
                </div>
              </div>
                <h4 className="text-center">{keys[err].msg}</h4>
            </div>
        </div>
    )
}